<template>
  <input v-if="user.isSalesManager" v-model="authManager.title" />
  <select-input-dict v-else label="title" v-model="managerCode" :select-list="managers" :options="managers" />
</template>

<script setup lang="ts">
import { computed, defineModel, watch } from "vue";

import SelectInputDict from "@/components/UI/SelectInputDict.vue";

import { useDictStore } from "@/stores/dictStore";
import { useUserStore } from "@/stores/userStore";
import { ManagerInfo } from "@/models/estimate";
import { useNewEstimateStore } from "@/stores/new/estimateStore";

const dictStore = useDictStore();
const user = useUserStore();
const estimateStore = useNewEstimateStore();
const isSalesManager = computed(() => user.isSalesManager);

const managers = dictStore.getManagers();
const authManager = computed(
  () => managers.filter((item) => item.code === user.userCode)[0],
);
const managerCode = defineModel<ManagerInfo | null>({
  default: null,
});

watch(
  () => isSalesManager,
  () => {
    if (isSalesManager.value) {
      managerCode.value = authManager.value.code;
    }
  },
  { immediate: true },
);

watch(
  () => managerCode.value,
  () => {
    estimateStore.estimate.managerCode = managerCode.value;
  },
  { immediate: true },
);
</script>

<style lang="scss" scoped></style>
